import React from 'react';
import PropTypes from 'prop-types';
import ReactImageMagnify from 'react-image-magnify';
import useS3PresignedUrl from 'hooks/useS3PresignedUrl';

const S3ReactImageMagnify = ({ bucket, objectKey, smallImageProps, largeImageProps, ...rest }) => {
  const url = useS3PresignedUrl(bucket, objectKey);

  if (!url) return null;

  return (
    <ReactImageMagnify
      {...rest}
      {...{
        smallImage: { ...smallImageProps, src: url },
        largeImage: { ...largeImageProps, src: url }
      }}
    />
  );
};

S3ReactImageMagnify.propTypes = {
  bucket: PropTypes.string.isRequired,
  objectKey: PropTypes.string.isRequired,
  smallImageProps: PropTypes.object.isRequired,
  largeImageProps: PropTypes.object.isRequired
};

export default S3ReactImageMagnify;
